import React from 'react';
import VirtualMachine from '../../../models/entities/VirtualMachine';
import {Table} from 'react-unity';
import moment from 'moment';

interface VirtualMachineTableProps {
    virtualMachine: VirtualMachine;
}

const VirtualMachinesTable = ({
	virtualMachine,
}: VirtualMachineTableProps) => {


	return (
		<Table.Body.Row key={virtualMachine.id}>
			<Table.Body.Cell>{virtualMachine.id}</Table.Body.Cell>
			<Table.Body.Cell>{virtualMachine.virtualMachineRequestId}</Table.Body.Cell>
			<Table.Body.Cell>{virtualMachine.virtualMachineName}</Table.Body.Cell>
			<Table.Body.Cell>{virtualMachine.environment}</Table.Body.Cell>
			<Table.Body.Cell>{moment(virtualMachine.date).format('MM/DD/YYYY')}</Table.Body.Cell>
		</Table.Body.Row>
	);
};

export default VirtualMachinesTable;